import { useState, useEffect } from 'react';
import IS_BROWSER from '../isBrowser/index.js';

var getWindowSize = function getWindowSize() {
  var _a, _b;
  var width = Math.min(window.innerWidth, ((_a = window === null || window === void 0 ? void 0 : window.screen) === null || _a === void 0 ? void 0 : _a.availWidth) || Infinity);
  var height = Math.min(window.innerHeight, ((_b = window === null || window === void 0 ? void 0 : window.screen) === null || _b === void 0 ? void 0 : _b.availHeight) || Infinity);
  return {
    width: width,
    height: height
  };
};
var useWindowSize = function useWindowSize() {
  var _a = useState(IS_BROWSER ? getWindowSize() : {
      width: 1024,
      height: 768
    }),
    windowSize = _a[0],
    setWindowSize = _a[1];
  useEffect(function () {
    if (IS_BROWSER) {
      var handleResize_1 = function handleResize_1() {
        return setWindowSize(getWindowSize());
      };
      window.addEventListener('resize', handleResize_1);
      handleResize_1();
      return function () {
        return window.removeEventListener('resize', handleResize_1);
      };
    }
  }, []);
  return windowSize;
};

export { useWindowSize as default };
//# sourceMappingURL=index.js.map
